export default "__VITE_ASSET__2Z4sv5bD__"